import React from 'react';
import classNames from 'classnames/bind';
import styles from "./styles.pcss";
var cn = classNames.bind(styles);
export var GridContainer = function GridContainer(_ref) {
  var isSkewed = _ref.isSkewed,
    children = _ref.children,
    gap = _ref.gap,
    maxColumns = _ref.maxColumns,
    noScroll = _ref.noScroll,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("div", {
    className: cn('container', noScroll ? 'overflow--initial' : 'overflow--scroll', isSkewed ? 'skewed' : 'normal', {
      quadro: maxColumns === 2
    }, "gap--".concat(gap || 'medium'), className),
    "data-t-id": "components-AutoGrid"
  }, /*#__PURE__*/React.createElement("div", {
    className: cn('containerIn')
  }, children));
};